/*eslint-disable jsx-a11y/no-static-element-interactions*/
import React from 'react'
import { connect } from 'react-redux'
import { showFileManager, setLockBackground } from '@/store/actions'
import IconComponent from '@/components/commons/IconComponent'

const UploadImage = props => {
  const { useIcon, showFileManager, setLockBackground, onImageSended } = props
  return (
    <div className="file-select">
      {!useIcon ? (
        <div
          className="image-select"
          onMouseDown={() => {
            showFileManager( {
              isOpened: true,
              callback: onImageSended
            } )
            setLockBackground( { isVisible: true } )
          }}
        >
          <i className="material-icons">cloud_upload</i>
          <span>{props.text}</span>
        </div>
      ) : (
        <button
          className="file-button"
          onMouseDown={() => {
            showFileManager( {
              isOpened: true,
              callback: onImageSended
            } )
            setLockBackground( { isVisible: true } )
          }}
        >
          <IconComponent icon="change-picture" />
        </button>
      )}
    </div>
  )
}

export default connect(
  null,
  { showFileManager, setLockBackground }
)( UploadImage )



// WEBPACK FOOTER //
// ./src/components/fileManager/UploadImage.js